'use strict';

var propTypes = {exports: {}};

exports.__module = propTypes;
//# sourceMappingURL=index2.cjs.map
